import { create } from "zustand";
import { devtools } from "zustand/middleware";
import { ITrustedDeviceItem } from "@evennt-tech/api-v2-external";
import { apiV2 } from "api/firebase";
import { registerStore } from "store/utils/reset-store.utils";

type State = {
  devices: ITrustedDeviceItem[] | null;
};

type Action = {
  fetchDevices: () => Promise<void>;
  revokeDevice: (id: string) => Promise<void>;
  revokeAll: () => Promise<void>;
};

export const useTrustedDevices = create(
  devtools<State & Action>(
    (set, get) => ({
      devices: null,

      fetchDevices: async () => {
        try {
          const devices = await apiV2.trustedDevice.get();
          set({ devices });
        } catch (error) {
          console.error("Failed to fetch trusted devices:", error);
          set({ devices: [] });
        }
      },

      revokeDevice: async (id) => {
        await apiV2.trustedDevice.revoke({ id });
        await get().fetchDevices();
      },

      revokeAll: async () => {
        await apiV2.trustedDevice.revokeAll();
        await get().fetchDevices();
      },
    }),
    { name: "trustedDevice" }
  )
);

registerStore(useTrustedDevices);
